import useGetApi from 'src/api/useGetApi';
import { WatchersResponse } from 'src/types/application/WatcherDTO';

interface UseWatchersParams {
  watchableEntityType: string;
  watchableId: string;
}

const useWatchers = (
  { watchableEntityType, watchableId }: UseWatchersParams,
  enabled = true,
) => {
  return useGetApi<WatchersResponse>({
    endpoint: `core/watches/${watchableEntityType}/${watchableId}`,
    options: {
      enabled: enabled && !!watchableEntityType && !!watchableId,
    },
  });
};

export default useWatchers;
